import { Link } from 'react-router-dom';
import { getLatestComics } from '@/mocks/comics';
import ComicCard from '@/components/feature/ComicCard';

export default function LatestUpdates() {
  const latestComics = getLatestComics(8);

  return (
    <section className="py-10 md:py-14 bg-background-50" aria-label="最新更新">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              <i className="ri-time-line text-secondary-500 mr-2"></i>
              最新更新
            </h2>
            <p className="text-sm text-foreground-500 mt-2">刚刚更新的韩漫章节，快来看看有没有你追的作品</p>
          </div>
          <Link
            to="/category/action"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            查看更多
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop>
          {latestComics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}